import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { marketingClient } from '@integration/api-client/marketing';

const { actions, effects } = generateNgrxServiceClient(
  'MarketingAPI',
  marketingClient
);

export {
  actions as marketingWrapperActions,
  effects as marketingWrapperEffects,
};
